export default {
  // Login page
  'Please login to your account': 'Connectez-vous à votre compte',
  'Login': 'Se Connecter',
  'Forgot Password': 'Mot de passe oublié',
  'Back to Login': 'Retour à la connexion',
  'Get Mobile App': 'Accéder à l\'application mobile',
  'Username': 'nom d\'utilisateur',
  'Password': 'Mot de passe',
  'Get Mail': 'Recevoir un courriel',
  'Password is required': 'Mot de passe exigé',
  'E-mail is required': 'Adresse e-mail est requise',
  'E-mail must be valid': 'L\'adresse e-mail doit être valide',
  'Scan QR code to download the app': 'Scanner le code QR pour télécharger l\'appli',
  // Set Password
  'Update': 'Mise à jour',
  'Set': 'Le mot de passe est défini',
  'Reset': 'Réinitialiser le mot the passe',
  'New Password': 'Nouveau mot de passe',
  'Confirm Password': 'Confirmer le mot de passe',
  'Show password': 'Montrer le mot de passe',
  'Submit': 'Soumettre',
  'Skip': 'Sauter',
  'Back': 'Retourner',
  'Resend email after 10 mins': 'Renvoyer l\'e-mail après {min} minutes',
  'Must have atleast 8 characeters': 'Doit comporter au moins 8 caractères',
  'Its better to have': 'Il est mieux d\'avoir',
  'Upper & lower case letters': 'Lettres majuscules et minuscules',
  'A symbol (#&$)': 'Un symbole (#&$)',
  'A numerical value (0-9)': 'Une chiffre (0-9)',
  'The longer the password, the better': 'Il est mieux de créer un mot de passe plus long',
  // 404 Page
  'Access Denied': 'Accès refusé',
  'Page Not Found': 'Page Non Trouvée',
  'sorry, but you don\'t have permission to access this page.': 'Excusez-nous, vous n\'avez pas l\'autorisation d\'accéder à cette page.',
  'You can go back to': 'Vous pouvez retourner à',
  'Sorry! The page you are requesting doesn\'t exist.':'Désolé ! La page que vous demandez n\'existe pas.',
  // Navigation
  'Last Update': 'Dernière mise à jour',
  'previous page': 'page précédente',
  'Home': 'Page d\'accueil',
  'Plant Overview': 'Aperçu de la centrale solaire',
  'Devices': 'Appareils',
  'Alert': 'Alerte',
  'Services': 'Rapports de service',
  'Support': 'Contactez-nous pour plus de soutien',
  'Logout': 'Se déconnecter',
  'Admin': 'Accès administratif',
  'For further queries contact': 'Contactez-nous pour plus de renseignements',
  // TOOL Bar
  'Notification': 'Notification',
  'View more': 'Voir plus',
  'Theme': 'Thème',
  'Auto-Refresh - Every': 'Rafraîchissement automatique - Toutes les 5 minutes',
  'Last Updated': 'Dernière mise à jour',
  'Single Click - Toggle Auto Reload': 'Clic simple - Basculer le rechargement automatique',
  'Double Click - Instant Refresh': 'Double-clic - Actualisation instantanée',
  'Fullscreen': 'Plein écran',
  'Select Language': 'Sélectionner la langue',
  'Grid': 'Réseau',
  'Inverter': 'Onduleur',
  // Dashboard change toolbar
  'Dashboard': 'Tableau de bord',
  // FILTER
  'APPLY': 'APPLIQUER',
  'Filter': 'Filtrer',
  'Select Date': 'Sélectionner une date',
  'Start Date': 'Date de début',
  'End Date': 'Date de fin',
  'Pick Date': 'Choisir la date',
  'Select All': 'Sélectionner tout',
  'Deselect All': 'Désélectionner tout',
  'Select device type': 'Sélectionnez le type d\'appareil',
  'Choose Date Range': 'Choisissez la plage de dates',
  'Select Date Range': 'Sélectionnez la plage de dates',
  'Last 3 days': '3 derniers jours',
  'Last 7 days': '7 derniers jours',
  'Last 30 days': '30 derniers jours',
  'Present month': 'Mois actuel',
  'Last month': 'Le mois dernier',
  'Last 3 months': 'Les 3 derniers mois',
  'Present Year': 'Année actuelle',
  'Last year': 'L\'année dernière',
  'Last Year': 'L\'année dernière',
  'Custom': 'Coutume',
  'Severity': 'Gravité',
  'Critical': 'Critique',
  'High': 'Haut',
  'Medium': 'Moyen',
  'Low': 'Faible',
  'Warning': 'Avertissement',
  'Info': 'Info',
  'Select an Interval': 'Sélectionnez un intervalle',
  'Select Time Range': 'Sélectionnez la plage horaire',
  'Use time range': 'Utiliser la plage horaire',
  'Select Date Format': 'Sélectionnez le format de date',
  'Select WS': 'Sélectionnez Station de Surveillance Météorologique',
  'Select Inverters': 'Sélectionnez Onduleurs',
  'Select Trackers': 'Sélectionnez Pisteurs',
  'hourly': 'toutes les heures',
  '30 mins': '30 mins',
  '15 mins': '15 mins',
  '10 mins': '10 mins',
  '5 mins': '5 mins',
  '1 mins': '1 mins',
  'to': 'de',
  'from': 'depuis',
  'for': 'pour',
  // HOME
  'Subscription Alert': 'Alerte d\'abonnement',
  'Total Plants': 'Centrales solaires totales',
  'AC CAPACITY': 'CAPACITÉ CA',
  'DC CAPACITY': 'CAPACITÉ CC',
  'Energy Today': 'Énergie produite aujourd\'hui',
  'Daily Updates': 'Mises à jour quotidiennes',
  'Search': 'Rechercher',
  'NAME': 'NOM',
  'Name': 'Nom',
  'LOCATION': 'EMPLACEMENT',
  'GEN(kWh)': 'PRODUCTION D\'ÉLECTRICITÉ (kWh)',
  'home PR(%)': 'RATIO DE PERFORMANCE (%)',
  'STATUS': 'STATUT',
  'New alert(s)': 'Nouvelles alerte(s)',
  'No alert(s)': 'Aucune alerte(s)',
  'MAP View': 'Voir la carte',
  'Filter Search': 'Filtrer la recherche',
  'Plant\'s name & Location': 'Nom et emplacement de la plante',
  'Plant\'s name': 'Nom de la plante',
  'Location': 'Emplacement',
  'Search by location': 'Rechercher par emplacement',
  'Search plants or locations': 'Rechercher des plantes ou des emplacements',
  'Search by plant name': 'Rechercher par nom de plante',
  'AC Capacity (kW)': 'Capacité en CA (kW)',
  'MAP': 'CARTE',
  'Carbon Footprint(Today)': 'Empreinte carbone (aujourd\'hui)',
  'CARBON FOOTPRINT (TODAY)': 'EMPREINTE CARBONE (AUJOURD\'HUI)',
  'CARBON FOOTPRINT': 'EMPREINTE CARBONE',
  'Tree Saplings Planted': 'Jeunes arbres plantés',
  'Trees Planted Today': 'Arbres plantés aujourd\'hui',
  'Eco Savings Today': 'Éco écologiques aujourd\'hui.',
  'Energy Yesterday': 'Énergie hier',
  'Trees Planted Yesterday': 'Arbres plantés hier',
  'Eco Savings Yesterday': 'Éco écologiques hier',
  'Energy This Month': 'Énergie ce mois-ci',
  'Trees Planted This Month': 'Arbres plantés ce mois-ci',
  'Eco Savings This Month': 'Éco écologiques ce mois-ci',
  'Energy This Year': 'Énergie cette année',
  'Trees Planted This Year': 'Arbres plantés cette année',
  'Eco Savings This Year': 'Éco écologiques cette année',
  'Search plant': 'Rechercher une centrale solaire',
  'House Lighted': 'Nombre de maisons éclairées',
  'Diesel Consumption Reduced': 'Consommation de diesel réduite',
  'CO2 emission Reduced': 'Émission de CO2 réduite',
  'Plant List': 'Liste des plantes',
  'Plant name': 'Nom de la plante',
  'View map': 'Voir la carte',
  // PlantOverview
  'WS Parameters': 'Station de Surveillance\nMétéorologique de paramètres',
  'Other Parameters': 'Autres paramètres',
  'Static Plant Info': 'Informations fixes sur la centrale solaire',
  'Bulletin': 'Bulletin',
  'NO DATA': 'AUCUNE DONNÉES',
  'No Data': 'Aucune Donnée',
  'No data': 'Aucune donnée',
  'no data': 'Aucune donnée',
  'Plant Details': 'Détails de la centrale solaire',
  'Yet To Compute': 'Encore à calculer',
  'Not Available': 'Pas disponible',
  'INV Gen (Today)': 'Production par onduleurs (Aujourd\'hui)',
  'INV Generation': 'Production par onduleurs',
  'INV PR': 'Ratio de performance Onduleurs',
  'INV CUF': 'Facteur d\'utilisation du Onduleurs',
  'AC Yield': 'Rendement CA',
  'Co2 Reduction': 'Émission de CO2 réduite',
  'Import Energy': 'Importation d\'energie',
  'Export Energy': 'Exportation d\'energie',
  'INV Down Time': 'Onduleurs du durée de l\'arrêt',
  'Grid Down Time': 'Réseau électrique du durée de l\'arrêt',
  'KPI Metrics': 'Paramètres principaux',
  'This month': 'Mois actuel',
  'This year': 'Année actuelle',
  'Monthly Revenue': 'Recette mensuelle',
  'Daily Revenue': 'Recette quotidienne',
  'INV Gen (Yesterday)': 'Production par onduleurs (hier)',
  'INV Gen (MTD)': 'Production par onduleurs (Mois jusqu\'à présent)',
  'INV Gen (YTD)': 'Production par onduleurs (Année jusqu\'à présent)',
  'INV Gen (ITD)': 'Production par onduleurs (Jour de l\'installation jusqu\'à présent)',
  'AC Capacity': 'Capacité en CA',
  'DC Capacity': 'Capacité en CC',
  'Data Logger Status': 'Statut de l\'enregistreur de données',
  'Live Temp': 'Température en direct',
  'AC Power (INV)': 'Alimentation CA (onduleur)',
  'Block CUF': 'Facteur d\'utilisation du bloc',
  'Block AC Yield': 'Rendement CA du bloc',
  'DC Power (INV)': 'Alimentation CC (onduleur)',
  'AC Yield (INV)': 'Rendement CA (onduleur)',
  'Peak Power (INV)': 'Puissance de crête (onduleur)',
  'CUF (INV)': 'Facteur d\'utilisation (onduleur)',
  'MFM Gen (Today)': 'Production par compteur multifonctions (Aujourd\'hui)',
  'MFM Gen (Yesterday)': 'Production par compteur multifonctions (hier)',
  'MFM Gen (MTD)': 'Production par compteur multifonctions (Mois jusqu\'à présent)',
  'MFM Gen (YTD)': 'Production par compteur multifonctions (Année jusqu\'à présent)',
  'MFM Gen (FTD)': 'MFM Gen (FTD)',
  'Efficiency': 'Efficacité',
  'Peak Power (MFM)': 'Puissance de crête (compteur multifonctions)',
  'AC Yield (MFM)': 'Rendement CA (compteur multifonctions)',
  'EM Gen (Today)': 'Production par compteur d\'énergie (Aujourd\'hui)',
  'EM Gen (Yesterday)': 'Production par compteur d\'énergie (hier)',
  'EM Gen (MTD)': 'Production par compteur d\'énergie (Mois jusqu\'à présent)',
  'EM Gen (YTD)': 'Production par compteur d\'énergie (Année jusqu\'à présent)',
  'Radiation Insolation': 'Isolation des rayonnements',
  'AC Power (EM)': 'Alimentation en courant alternatif (compteur d\'énergie)',
  'AC Yield (EM)': 'Rendement CA (compteur d\'énergie)',
  'CUF (EM)': 'Facteur d\'utilisation (compteur d\'énergie)',
  'EM Gen (FTD)': 'EM Gen (FTD)',
  'Peak Power (EM)': 'Puissance de crête (compteur d\'énergie)',
  'AC Power (MFM)': 'Alimentation CA (compteur multifonctions)',
  'Plant AC Yield': 'Rendement CA de la centrale solaire',
  'Inv Start': 'Heure de début de l\'onduleur',
  'Inv Stop': 'Heure de fin de l\' onduleur',
  'Inst. PA (%)': 'Disponibilité de la centrale solaire à tout moment (%)',
  'Inst. GA (%)': 'Disponibilité de la réseau électrique à tout moment (%)',
  'Grid Status': 'Statut du réseau électrique',
  'Plant Availability': 'Disponibilité de la centrale solaire',
  'Grid Availability': 'Disponibilité du réseau électrique',
  'Map View': 'Vue de la carte',
  'INV ROOM': 'Salle des onduleurs',
  'INV': 'Onduleur',
  'generation': 'Production',
  'pr': 'Ratio de Performance',
  'cuf': 'Facteur d\'utilisation',
  'PR INV': 'Ratio de performance Onduleurs',
  'EM PR': 'Ratio de performance Compteur d\'énergie',
  'MFM PR': 'Ratio de performance Compteur multifonctions',
  // INVERTER DB
  'Dip Reason': 'Raison de la chute',
  'NO ALERTS': 'AUCUNE ALERTE',
  'Created Time': 'Heure de création',
  'Resolved Time': 'Heure de la résolution',
  'Created time': 'Heure de création',
  'Resolved time': 'Heure de la résolution',
  'Block List': 'Liste de blocs',
  'Total Inv Gen': 'Production totale par onduleurs',
  'Generation Graph': 'Graphique de production',
  'Power Graph': 'Graphique de puissance',
  'Plant Total Graph': 'Graphique total de la centrale solaire',
  'Plant Total': 'Total de la centrale solaire',
  'Energy': 'Énergie',
  'Power': 'Puissance',
  'Current': 'Courant',
  'Select Graph': 'Sélectionnez le graphique',
  'Graph Type': 'Type de graphique',
  'Total': 'Totale',
  'Yield': 'Rendement',
  'Inverter Wise': 'En fonction de l\'onduleur',
  'Generation (kWh)': 'Production (kWh)',
  'Irradiance (W/m²)': 'Irradiance (W/m²)',
  // MFM DB
  'MFM List': 'Liste de compteur multifonctions',
  'Export (kWh)': 'Exportée (kWh)',
  'AC Power (KW)': 'Alimentation en courant alternatif (KW)',
  // MFM Graph
  'R Phase(V)': 'Phase rouge (V)',
  'B Phase(V)': 'Phase bleue (V)',
  'YB-line(V)': 'Ligne jaune-bleue (V)',
  'Current R(A)': 'Courant rouge (A)',
  'Current B(A)': 'Courant bleu (A)',
  'AC Power(kw)': 'Alimentation en courant alternatif (kw)',
  'Export(kWh)': 'Exportée (kWh)',
  'Temperature(c)': 'Température (°c)',
  'Temperature(°c)': 'Température (°c)',
  'Y Phase(V)': 'Phase jaune (V)',
  'RY-line(V)': 'Ligne rouge-jaune (V)',
  'BR-line(V)': 'Ligne bleue-rouge (V)',
  'Current Y(A)': 'Courant jaune (A)',
  'Frequency(Hz)': 'Fréquence (Hz)',
  'Import(kWh)': 'Importée (kWh)',
  'Reactive Power(kVAR)': 'Pouvoir réactif (kVAR)',
  // Weather Station
  'Graph': 'Graphique',
  'Table': 'Tableau',
  // Weather Station Header
  'Module Temperature': 'Température des modules',
  'Ambient Temperature': 'Température ambiante',
  'GHI': 'Irradiance Horizontale Globale',
  'PoA': 'Plan du réseau',
  'Humidity': 'Humidité',
  'Wind Direction': 'Direction du vent',
  'LIVE': 'EN DIRECT',
  'MIN': 'MIN',
  'MAX': 'MAX',
  'AVG': 'MOYENNE',
  'LAST PACKET': 'DERNIER PAQUET REÇU',
  'CUMULATIVE': 'CUMULATIF',
  // Weather Station Graph
  'Irradiance PoA': 'Irradiance du plan du réseau',
  'Irradiance GHI': 'Irradiance de l\'irradiance horizontale globale',
  'Radiation': 'Rayonnement',
  'Pressure': 'Pression',
  // TRACKER
  'Accuracy (%)': 'Précision (%)',
  'Operation Mode': 'Mode d\'Opération',
  // ADVANCED SCB
  // SCB Table
  'Ch Ref Id': 'Identification de la référence du canal',
  'Channel Ref. Id for Underperforming String': 'Identification de la référence du canal pour les cordes sous-performantes',
  'Select All Channels': 'Sélectionner tous les canaux',
  'Total Current': 'Courant Total',
  'Voltage': 'Tension',
  'Temp': 'Température',
  'DC Power': 'Alimentation en courant continu',
  'Breaker Status': 'Statut du disjoncteur',
  'SPD Status': 'Statut du dispositif de protection contre les surtensions',
  'ON': 'ALLUMER',
  'OFF': 'ÉTEINDRE',
  'Intact': 'Intacte',
  'Blown': 'Fusible grillé',
  // ZMU
  'Multiplication Factor': 'Facteur de multiplication',
  'Total Power': 'Pouvoir total',
  // STRING INVERTER
  'Please select String Inverters in order to check the graph': 'Sélectionnez les onduleurs à cordes pour consulter le graphique',
  'Please select the channels in order to check graph': 'Sélectionner les canaux afin de vérifier le graphique',
  'Equipment': 'Équipement',
  'Voltage(V)': 'Tension(V)',
  'Power(kW)': 'Pouvoir(kW)',
  'Temperature(°C)': 'Température(°C)',
  // ADVANCED STRING INVERTER
  'Total Power (kW)': 'Pouvoir total (kW)',
  // ZONE MONITORING
  'Channel': 'Canal',
  'Equipment [Block / Room / Device Name]': 'Équipement [Bloc / Salle / Nom d\'appareil]',
  // LIVE DASHBOARD
  'Live Data': 'Données en direct',
  'MFM Name': 'Nom de compteur multifonctions',
  'Export(kWh)': 'Exporter(kWh)',
  'Import(kWh)': 'Importer(kWh)',
  'INV Name': 'Nom d\'onduleur',
  'AC Yield (Inverter)': 'Rendement CA (onduleur)',
  'CUF (Inverter)': 'Facteur d\'utilisation (onduleur)',
  'CUF (MFM)': 'Facteur d\'utilisation (compteur multifonctions)',
  'EM Name': 'Nom de compteur d\'énergie',
  'SMB Name': 'Nom de boîte combinatoire de cordes',
  // ALERT
  'Alert': 'Alerte',
  'Equipments': 'Équipements',
  'Alert Details': 'Détails de l\'alerte',
  'New': 'Nouvelle',
  'Acknowledge': 'Confirmer',
  'Resolved': 'Résolu',
  'ASC': 'ASCENDANTE',
  'DESC': 'DESCENDANT',
  'Status': 'Statut',
  'Code': 'Code',
  'Manual Alert': 'Alerte manuelle',
  'communication': 'communication',
  'Grid Failure': 'Défaillance de réseau',
  'Network Failure': 'Défaillance du réseau',
  'Grid Failure/Network Failure': 'Panne de réseau/panne de réseau',
  'VCB "Breaker Name" Failure': 'Défaillance du \'nom du disjoncteur\' du disjoncteur à vide',
  'INV Not Started/Failure': 'Onduleur non démarré/défaillance',
  'SMB Failure': 'Défaillance de la boîte de combinaison de la corde',
  'PoA_Value: Out of Range': 'Valeur de Plan du réseau: Hors de Gamme',
  'GHI_Value: Out of Range': 'Valeur de Irradiance Horizontale Globale: Hors de Gamme',
  'Ambient Temperature: Out of Range': 'Température ambiante : Hors de la plage',
  'Module Temperature: Out of Range': 'Température du panneau solaire : Hors de la plage',
  'Wind Direction : Out of Range': 'Direction du vent : Hors de la plage',
  'Communication Failure': 'Défaillance de la communication',
  'Grid/Communication Failure': 'Défaillance du réseau/de la communication',
  'Start Time': 'Heure de démarrage',
  'Message': 'Message',
  'Alert Message': 'Message d\'alerte',
  'computed': 'calculé',
  'Device': 'Appareil',
  'Resolve': 'Résoudre',
  'Time': 'Heure',
  'Updated by': 'Mis à jour par',
  'Added by': 'Ajouté par',
  'Stats': 'Statistiques',
  // DOWN TIME ANALYSIS
  'DOWN TIME': 'DURÉE DE L\'ARRÊT',
  'Down Time': 'Durée de l\'arrêt',
  'DOWN ENERGY': 'BAISSE DE L\'ÉNERGIE',
  'Energy Loss': 'Perte d\'énergie',
  'GRAPH': 'GRAPHIQUE',
  'Not Down': 'PAS EN BAISSE',
  'Loss': 'Perte',
  'Date': 'Date',
  'State': 'État',
  'Calculated Energy loss when Solar PV plant is not generating power due to technical failures (Grid/Inverter). This Energy is calculated based on the irradiance value and inverter capacity': `Perte d'énergie calculée lorsque la centrale solaire photovoltaïque ne produit pas d'électricité en raison de défaillances techniques (réseau/onduleur). Cette énergie est calculée en fonction de la valeur de l'irradiation et de la capacité de l'onduleur.`,
  'Time when the PV system cannot provide power to the load, downtime may be due to technical failure of the solar plant or maintenance of the solar plant.': `Le temps pendant lequel le système photovoltaïque ne peut pas fournir d'électricité à la charge, le durée d'arrêt peut être dû à une défaillance technique de l'installation solaire ou à la maintenance de l'installation solaire.`,
  // FORECAST
  'Next hour forecast': 'Prévision de l\'heure suivante',
  'Irradiance': 'Irradiance',
  'Generation Data': 'Données de production',
  'Data upto previous hour': 'Données jusqu\'à l\'heure précédente',
  'Actual Gen': 'Production réelle',
  'Forecasted Gen': 'Production prévue',
  'Penalty Trend': 'Tendance des amendes',
  'Trend compared upto previous hour': 'Tendance par rapport à l\'heure précédente',
  'Today': 'Aujourd\'hui',
  'Yesterday': 'Hier',
  'Today\'': 'Aujourd\'hui',
  'Yesterday\'': 'Hier',
  'Trend': 'Tendance',
  'Actual Data vs Forecasted Data': 'Données réelles vs données prévues',
  'Data comparision for actual generation vs forecasted generation': 'Comparaison des données relatives à la production réelle et à la production prévue',
  'Deviation': 'Déviation',
  'Revision': 'Révision',
  'Trend Table': 'Tableau des tendances',
  'Generation/weather parameters trend': 'Tendance des paramètres de production/météo',
  'Actual': 'Réel',
  'Forecast': 'Prévision',
  'Range and Deviation': 'Gamme et déviation',
  'Trend': 'S\'orienter',
  'Generation vs Penalty': 'Production vs amende',
  'Data compared to deviation range': 'Données comparées à la gamme déviation',
  'Range': 'Gamme de données',
  'Penalty': 'Amende',
  'Previous Revision Id': 'Révisions précédentes effectuées',
  'Forecast Generation (MWh)': 'Prévision de la production (MWh)',
  'sunny': 'Ensoleillé',
  'mostly sunny': 'Principalement ensoleillé',
  'partly sunny': 'Partiellement ensoleillé',
  'intermittent clouds': 'Nuages intermittents',
  'hazy sunshine': 'Soleil brumeux',
  'mostly cloudy': 'Principalement nuageux',
  'cloudy': 'Nuageux',
  'dreary (overcast)': 'Morne (couvert)',
  'fog': 'Pluies',
  'showers': 'Douches',
  'mostly cloudy w/ showers': 'Principalement nuageux avec des pluies',
  'partly sunny w/ showers': 'Partiellement ensoleillé avec des pluies',
  't-storms': 'Orages',
  'mostly cloudy w/ t-storms': 'Principalement nuageux avec des orages',
  'partly sunny w/ t-storms': 'Partiellement ensoleillé avec des orages',
  'rain': 'Pluie',
  'flurries': 'Averses',
  'mostly cloudy w/ flurries': 'Principalement nuageux avec des averses',
  'partly sunny w/ flurries': 'Partiellement ensoleillé avec des averses',
  'snow': 'Neige',
  'mostly cloudy w/ snow': 'Principalement nuageux avec de la neige',
  'ice': 'Glace',
  'sleet': 'Grésil',
  'freezing rain': 'Pluie verglaçante',
  'rain and snow': 'Pluie et neige',
  'hot': 'Chaud',
  'cold': 'Froid',
  'windy': 'Venteux',
  'clear': 'Dégagé',
  'mostly clear': 'Principalement dégagé',
  'partly cloudy': 'Partiellement nuageux',
  'hazy moonlight': 'Clair de lune brumeux',
  'partly cloudy w/ showers': 'Partiellement nuageux avec des averses',
  'partly cloudy w/ t-storms': 'Partiellement nuageux avec des orages',
  // OTHER SENSOR
  'SHOW DETAILS': 'AFFICHER LES DÉTAILS',
  'Block': 'Bloc',
  'Inverter Room': 'Salle des onduleurs',
  'Sensor Time': 'Durée du capteur',
  'Sensor Reading Time': 'Temps de relevé du capteur',
  'Import Cumulative (kWh)': 'Importation cumulée (kWh)',
  'Export Cumulative (kWh)': 'Exportation cumulée (kWh)',
  'Total Import (kWh)': 'Importation totale (kWh)',
  'Total Export (kWh)': 'Exportation totale (kWh)',
  'R-Phase (kV)': 'Phase rouge (kV)',
  'Y-Phase (kV)': 'Phase jaune (kV)',
  'B-Phase (kV)': 'Phase bleue (kV)',
  'Frequency (Hz)': 'Fréquence (Hz)',
  'L1 (A)': 'Ligne 1 (A)',
  'L2 (A)': 'Ligne 2 (A)',
  'L3 (A)': 'Ligne 3 (A)',
  'Daily Import (kWh)': 'Importation quotidienne (kWh)',
  'Daily Export (kWh)': 'Exportation quotidienne (kWh)',
  'AC Power (kW)': 'Alimentation CA',
  'Peak Power (kW)': 'Puissance de crête (kW)',
  'Reactive Power (kW)': 'Pouvoir réactif (kW)',
  'Soiling Ratio 1 (%)': 'Taux de salissure 1 (%)',
  'Soiling Ratio 2 (%)': 'Taux de salissure 2 (%)',
  'Transmit Loss 1 (%)': 'Perte pendant la transmission 1 (%)',
  'Transmit Loss 2 (%)': 'Perte pendant la transmission 2 (%)',
  'Ref Module Temp(°C)': 'Température du panneau solaire de référence (°C)',
  'Test Module Temp(°C)': 'Température du panneau d\'essai solaire (°C)',
  'SR Daily Avg(%)': 'Taux de salissure moyenne quotidienne (%)',
  'SP Daily Avg(%)': 'Pourcentage de salissure moyenne quotidienne (%)',
  'Geff Ref(W/m²)': 'Rayonnement de référence (W/m²)',
  'Geff Test(W/m²)': 'Rayonnement de test(W/m²)',
  'ISC Ref(A)': 'Courant de court-circuit de référence (A)',
  'ISC Test(A)': 'Courant de court-circuit de test (A)',
  'Soil Ratio(%)': 'Taux de sol(%)',
  'Soil Percentage(%)': 'Pourcentage de sol(%)',
  'AC output voltage (V)': 'Tension de sortie en courant alternatif (V)',
  'AC input voltage (V)': 'Tension d\'entrée en courant alternatif (V)',
  'Battery Voltage (V)': 'Tension de la batterie (V)',
  'Current Load (kW)': 'Charge de courant (kW)',
  'Invalid Voltage(V)': 'Tension invalide (V)',
  'Battery Temperature(°C)': 'Température de la batterie (°C)',
  'Actual OT (°C)': 'Température réelle de l\'huile (°C)',
  'Actual WT (°C)': 'Température réelle du bobinage (°C)',
  'Max OT (°C)': 'Température maximale de l\'huile (°C)',
  'Max WT (°C)': 'Température maximale du bobinage (°C)',
  'OT Alarm Set (°C)': 'Alarme de température d\'huile réglée (°C)',
  'OT Trip Set (°C)': 'Déclencheur de la température de l\'huile est réglé (°C)',
  'WT Alarm Set (°C)': 'Alarme de température de bobinage est réglée (°C)',
  'WT Trip Set (°C)': 'Déclencheur de la température du bobinage est activé (°C)',
  'Tracker Angle': 'Angle du pisteur',
  'Actual Angle': 'Angle réel',
  'Input Voltage': 'Tension d\'entrée',
  'Deviation Angle': 'Angle de déviation',
  'Mode Status': 'Statut de mode',
  'Wind Speed': 'Vitesse du vent',
  'Error Status': 'Statut d\'erreur',
  'Breaker ON': 'Disjoncteur est activé',
  'Breaker OFF': 'Disjoncteur est désactivé',
  'Breaker Trip': 'Disjoncteur est déclenché',
  'Local': 'Local',
  'Remote': 'À distance',
  'Test': 'Test',
  'Trip Circuit': 'Circuit de déclenchement',
  'DC Supply': 'Alimentation CC',
  // INVERTER RANKING
  'Overall Performance': 'Performance globale',
  'Overall performance info': 'Informations sur les performances globales',
  'Overall performance of inverter is derived from individual ranking buckets. Lower the points(pts) will be considered as higher in performance.': 'Les performances globales de l\'onduleur sont calculées à partir des classements différents. Plus les points sont bas, plus les performances sont élevées.',
  'Ranking Trends': 'Tendances de classement',
  'Present Month': 'Mois actuel',
  'Last Month': 'Le mois dernier',
  'up': 'classement supérieur',
  'down': 'classement inférieur',
  'Best': 'Meilleur',
  'Least': 'Le moins',
  'others': 'les autres',
  'Other best inv': 'Autres onduleurs les mieux classés',
  'Other least inv': 'Autres onduleurs les moins bien classés',
  'Best Performing Inverter': 'Onduleur le plus performant',
  'trend compared to prior month\'s PR': 'tendance par rapport au taux de performance du mois précédent',
  'Highest ranked Inverters': 'Onduleurs les mieux classés',
  'Best inverters': 'Les meilleurs onduleurs',
  'Present & Last month': 'Mois actuel et mois précédent',
  'PRESENT': 'ACTUEL',
  'LAST': 'DERNIER',
  'Trend compared to prior month (%)': 'Tendance par rapport au mois précédent (%)',
  'Current month\'s PR (%)': 'Taux de performance du mois actuel (%)',
  'Prior month\'s PR (%)': 'Taux de performance du précédent (%)',
  'PR\'S NOT CONFIGURED': 'Taux de performance pas configuré',
  'Inverter Ranking based on': 'Classement des onduleurs basé sur',
  'sorted in descending order': 'triés en ordre décroissant',
  'Performance Summary': 'Résumé des performances',
  'Performance info': 'Informations sur les performances',
  'viewing based on': 'visionnement basé sur',
  'Overall Performance based on': 'Performance globale basée sur',
  'Data Table': 'Tableau de données',
  'Aggregate values for all parameters': 'Valeurs cumulées pour tous les paramètres',
  'Heat Map': 'Carte de chaleur',
  'Inverter data visualization vs parameters': 'Visualisation des données de l\'onduleur par rapport aux paramètres',
  'Down Time(min)': 'Durée de l\'arrêt (min)',
  'Down\nTime Energy(kWh)': 'Temps \nd\'arrêt de\nl\'énergie (kWh)',
  'AC Yield(kW)': 'Rendement CA(kW)',
  'Efficiency(%)': 'Efficacité(%)',
  'Above 80': 'Au-dessus de 80',
  'Between 75 & 80': 'Entre 75 & 80',
  'Below 75': 'En dessous de 75',
  'Above 98': 'Au-dessus de 98',
  'Between 90 & 98': 'Entre 90 & 98',
  'Below 90': 'En dessous de 90',
  'Generation above "4*INV DC Capacity)"': 'Génération au-dessus de (4*capacité en courant continu de l\'onduleur)',
  'Above 4': 'Au-dessus de 4',
  'Between 3.5 & 4': 'Entre 3.5 & 4',
  'Below 3.5': 'En dessous de 3.5',
  'Below 10 min': 'Moins de 10 min',
  'Between 10min & 15min': 'Entre 10 min et 15 min',
  'More than 15min': 'Plus de 15 min',
  'Below 60': 'En dessous de 60',
  'Between 60 & 100': 'Entre 60 et 100',
  'More than 100': 'Plus de 100',
  'Total Points': 'Total des points',
  // SLD
  'Value 0': 'Valeur 0',
  'Any value 1': 'N\'importe quelle valeur 1',
  'IN/OUT TAG': 'ÉTIQUETTE D\'ENTRÉE ET DE SORTIE',
  'Change View to': 'Changer la vue en',
  'Input': 'Entrée',
  'Output': 'Sortie',
  'Value': 'Valeur',
  // CUSTOM REPORT
  'Fetching Report': 'Récupération du rapport',
  'REPORTS': 'RAPPORTS',
  'No template configured': 'Aucun modèle configuré',
  'Plant Level': 'Niveau de la centrale solaire',
  'Block Level': 'Niveau du bloc',
  'Device Level': 'Niveau de l\'appareil',
  'INV Level Gen': 'Production au niveau de l\'onduleur',
  'INV Gen': 'Production par onduleur',
  ' INV Gen': ' Production par onduleur',
  'EM Level Gen': 'Production au niveau du compteur d\'énergie',
  'EM Gen': 'Production par compteur d\'énergie',
  ' EM Gen': ' Production par compteur d\'énergie',
  'MFM Level Gen': 'Production au niveau du compteur multifonctions',
  'Performance Report': 'Rapport de performance',
  ' Performance Report': ' Rapport de performance',
  'Summary Report': 'Rapport sommaire',
  ' Summary Report': ' Rapport sommaire',
  'Device Report': 'Rapport de l\'appareil',
  ' Device Report': ' Rapport de l\'appareil',
  'Inverter level generation report': 'Rapport de production de niveau d\'onduleur',
  'Plant level inverter generation report': 'Rapport de production de l\'onduleur au niveau de la centrale solaire',
  'Block level inverter generation': 'Production d\'onduleurs au niveau du bloc',
  'Energy meter level generation report': 'Rapport de production au niveau du compteur d\'énergie',
  'MFM level generation report': 'Rapport de production au niveau du compteur multifonctions',
  'Plant level energy meter generation report': 'Rapport de production du compteur d\'énergie au niveau de la centrale solaire',
  'Device Level Performance Report': 'Rapport de performance au niveau de l\'appareil',
  'Plant Summary Report': 'Rapport sommaire de la centrale solaire',
  'Block Level Device Report': 'Rapport des appareils au niveau du bloc',
  'GRAPHICAL REPORTS': 'RAPPORTS GRAPHIQUES',
  'TABULAR REPORTS': 'RAPPORTS TABULAIRES',
  'POA Insolation (kWh/m²)': 'Insolation du plan du réseau (kWh/m²)',
  'INV GEN (kWh)': 'Production par onduleur (kWh)',
  'POA (W/m²)': 'Plan du réseau (W/m²)',
  // PLANT ANALYTICS
  'SAVE TEMPLATE': 'SAUVEGARDER LE MODÈLE',
  'POP Graph': 'Aperçu de la centrale solaire graphique',
  'Push to Plantoverview Graph': 'Pousser vers le Aperçu de la centrale solaire graphique',
  'Plant Analogue': 'Analogue de centrale solaire',
  'Plant KPI\'s': 'Indice des paramètres principaux de la centrale solaire',
  'Select Plants/Devices': 'Sélectionner les centrales solaires / les appareils',
  'Select Parameters': 'Sélectionnez les paramètres',
  'KPI\'s are inverter based': 'Les indices des paramètres principaux sont basés sur les onduleurs',
  'RETRIEVE': 'RÉCUPÉRER',
  'Retrieve the Saved Templates': 'Récupérer les modèles sauvegardés',
  'Plot Graph/Table': 'Tracer un graphique/tableau',
  'VIEW': 'Visionner',
  'Save As Template': 'Sauvegarder en tant que modèle',
  'Select Options in order to check data at Plant Level or Device Level': 'Sélectionner les options afin de vérifier les données au niveau de la centrale solaire ou de l\'appareil.',
  'Are you sure, you wanna delete this template': 'Êtes-vous sûr(e) de vouloir supprimer ce modèle?',
  'You can only save upto 5 Templates max.Please remove one of the Pre-saved Template, in order to proceed.': 'Vous ne pouvez sauvegarder que jusqu\'à 5 modèles au maximum. Veuillez supprimer l\'un des modèles pré-enregistrés pour continuer.',
  'Please Select Parameters': 'Veuillez sélectionner les paramètres requis',
  'Template Saved Successfully': 'Le modèle a été enregistré avec succès',
  'Failed to save template!': 'La sauvegarde du modèle a échoué!',
  'Template Deleted Successfully': 'Modèle supprimé avec succès',
  'Failed to delete template!': 'Échec de la suppression du modèle.',
  'Please Select Plant/Parameters': 'Veuillez sélectionner une centrale solaire/paramètres',
  'Refresh': 'Rafraîchir',
  'Download Image': 'Télécharger l\'image',
  'Download CSV': 'Télécharger en format CSV',
  'Enter Template Name': 'Saisir le nom du modèle',
  'Search Plant': 'Rechercher une centrale solaire',
  'Search Device': 'Rechercher un appareil',
  // INVERTER CONTROL
  'CONTROL': 'CONTRÔLER',
  'CHANGE INVERTER STATE': 'CHANGER L\'ÉTAT DE L\'ONDULEUR',
  'Change inverter state': 'Changer l\'état de l\'onduleur',
  'CHANGE SELECTED INVERTER STATE': 'CHANGER L\'ÉTAT DE L\'ONDULEUR SÉLECTIONNÉ',
  'Are you sure to change': 'Êtes-vous sûr de changer',
  'Sorry Connection Lost with Device': 'Désolé, la connexion avec l\'appareil est perdue',
  'Updated Successfully': 'Mise à jour effectuée avec succès',
  'Failed! Retry again': 'Échoué! Réessayez',
  'Username or password entered is incorrect': 'Le nom d\'utilisateur ou le mot de passe saisi est incorrect',
  'Enter the Password': 'Saisir le mot de passe',
  'Email': 'E-mail',
  'Reject': 'Rejeter',
  'Please Enter Power Factor Value Between': 'Saisir la valeur du facteur de puissance entre',
  'Please enter an integer': 'Saisir un nombre entier',
  'Please Enter Active Power Value Between': 'Saisir la valeur de la puissance active entre',
  'Please Enter Reactive Power Value Between': 'Saisir la valeur de puissance réactive entre',
  'Are You Sure To Change': 'Êtes-vous sûr de changer',
  'Are you sure you want to change the state': 'Êtes-vous sûr de vouloir changer l\'état',
  'Connected': 'Connecté',
  'Connection Lost': 'Connexion perdue',
  'Current status of': 'Statut actuel de',
  'is': 'est',
  'is currently': 'est actuellement',
  'POWER FACTOR': 'FACTEUR DE PUISSANCE',
  'REACTIVE POWER': 'PUISSANCE RÉACTIVE',
  'ACTIVE POWER': 'PUISSANCE ACTIVE',
  'Archive': 'Archive',
  'Data is available per week': 'Les données sont disponibles par semaine',
  'Archive Content': 'Archiver le contenu',
  'File': ' Dossier',
  'Date From': 'Date de',
  'Date To': 'Date à',
  'Actions': 'Actions',
  'Rows per page:': 'Lignes par page:',
  'String Evaluation': 'Évaluation de cordes',
  'Ref String': 'Corde de référence',
  'Ref Value': 'Valeur de référence',
  'Current (A)': 'Courant',
  'Deviation (%)': 'Déviation (%)',
  'Evaluation': 'Évaluation',
  // THINK HOME
  'DATA LOGGERS': 'ENREGISTREURS DE DONNÉES',
  'Performance Ratio': 'Ratio de performance',
  'DC CAPACITY': 'CAPACITÉ CC',
  'ENERGY TODAY': 'L\'ÉNERGIE AUJOURD\'HUI',
  'Monthly PR': 'Ratio de performance mensuel',
  'Annual PR': 'Ratio de performance annuel',
  'Monthly CUF': 'Facteur d\'utilisation mensuel',
  'Annual CUF': 'Facteur d\'utilisation annuel',
  'City': 'Ville',
  'Yield (kWh/kWp)': 'Rendement (kWh/kWp)',
  'Insolation': 'Insolation',
  'PR (%)': 'Ratio de performance (%)',
  'Your search for': 'Votre recherche pour',
  'found no results': 'a trouvé aucun résultat',
  'Plant Alerts': 'Alertes de centrales solaires',
  'Download': 'Télécharger',
  'Select an alert': 'Sélectionnez une alerte',
  'Please select an option': 'Sélectionner une option',
  'There was some error while loading the data. Please try again!!': 'Une erreur s\'est produite pendant le chargement des données. Réessayer!!',
  'Select Interval': 'Sélectionnez l\'intervalle',
  'Select Device': 'Sélectionnez un appareil',
  'Select INV ROOM': 'Sélectionner la salle de l\'onduleur',
  'Select Block': 'Sélectionnez le bloc',
  'Selected date exceeds 30 days': 'La date sélectionnée dépasse 30 jours',
  'No Data for Specific Date\'s': 'Aucune donnée pour les dates spécifiées',
  'No Data Available': 'Aucune donnée disponibles',
  'Cannot download data more than 15 days': 'Impossible de télécharger plus de 15 jours de données',
  'Cannot download data more than a month': 'Impossible de télécharger plus d\'un mois de données',
  'Cannot Download data beyond 180 days': 'Impossible de télécharger les données au-delà de 180 jours',
  'Please Select an interval': 'Sélectionner un intervalle',
  'Please Select valid parameters': 'Sélectionner des paramètres valides',
  'Please Select a Device': 'Sélectionner un appareil',
  'Device Name': 'Nom de l\'appareil',
  // Legend Text
  'Known Issue': 'Problème connu',
  'Under Performing': 'Sous performante',
  'String Underperforming': 'La corde est sous performante',
  'Comm Error': 'Erreur de communication',
  'NC': 'Pas Connecté',
  'Selected': 'Sélectionné',
  'On / Healthy / Okay': 'On / En bonne santé / D`accord',
  'Off / Fault / Not Okay': 'Éteint / Défaut / Pas bon,',
  'No Communication': 'Pas de communication.',
  // COMMON TERMINOLOGY
  'Show Graph': 'Afficher le graphique',
  'Show Table': 'Afficher le tableau',
  'Selected Items': 'Éléments sélectionnés',
  'Clear Selection': 'Effacer la sélection',
  'Clear All': 'Effacer tout',
  'Live': 'En direct',
  'Average': 'Moyenne',
  'Avg': 'Moyenne',
  'Computed': 'Calculé',
  'Raw': 'Brut',
  'Note': 'Noter',
  'Not Connected': 'Pas connecté',
  'Click to make it stick': 'Cliquez pour le faire coller',
  'Cancel': 'Annuler',
  'Send': 'Envoyer',
  'UP': 'Défiler vers le haut',
  'DOWN': 'Défiler vers le bas',
  'Reason': 'Raison',
  'Remarks': 'Remarques',
  'Parameters': 'Paramètres',
  'Any Comments': 'Commentaires',
  'NO': 'NON',
  'YES': 'OUI',
  'Yes': 'Oui',
  'select': 'sélectionner',
  'Select': 'Sélectionner',
  // COMMON HEADER
  'EM Generation': 'Production par compteur d\'énergie',
  'Generation': 'Production',
  'PR': 'Ratio de performance',
  'GHI Insolation': 'Insolation de l\'irradiation horizontale globale',
  'Wind Speed': 'Vitesse du vent',
  'Temperature': 'Température',
  'PoA Insolation': 'Insolation du plan de réseau',
  'Loading': 'Chargement',
  'Indicates required field': 'Indique un champ obligatoire',
  'This field is required': 'Ce champ est obligatoire',
  'SUBMIT': 'SOUMETTRE',
  'N/A': 'Pas applicable',
  'n/a': 'Pas applicable',
  'Close': 'Fermer',
  'Hey, Wait': 'Éviter tant de clics',
  'Disagree': 'En désaccord',
  'Agree': 'Accepter',
  'CANCEL': 'ANNULER',
  'SAVE': 'SAUVEGARDER',
  // Progress Bar
  'Please Wait': 'Attendez s\'il vous plaît',
  // GLOBAL PARAMETERS
  // Devices
  'Annunciator': 'Annonciateur',
  'ANNUNCIATOR': 'ANNONCIATEUR',
  'annunciator': 'annonciateur',
  'EM': 'Compteur d\'énergie',
  'Energy Meter': 'Compteur d\'énergie',
  'ENERGY METER': 'COMPTEUR D\'ÉNERGIE',
  'energy meter': 'Compteur d\'énergie',
  'MFM': 'Compteur Multifonctions',
  'mfm': 'Compteur multifonctions',
  'SMB': 'Soîte combinatoire de cordes',
  'smb': 'Soîte combinatoire de cordes',
  'Weather Station': 'Station de Surveillance Météorologique',
  'WEATHER STATION': 'STATION DE SURVEILLANCE MÉTÉOROLOGIQUE',
  'weather station': 'Station de surveillance météorologique',
  'ZMU': 'I\'appareil de surveillance de zone',
  'zmu': 'I\'appareil de surveillance de zone',
  'MPPT': 'Suivi du point de puissance maximale', 
  'mppt': 'Suivi du point de puissance maximale', 
  'Relay': 'Relais électrique',
  'RELAY': 'RELAIS ÉLECTRIQUE',
  'relay': 'Relais électrique',
  'Soil Sensor': 'Senseur de sol',
  'SOIL SENSOR': 'SENSEUR DE SOL',
  'soil sensor': 'Senseur de sol',
  'Tracker': 'Pisteur',
  'TRACKER': 'PISTEUR',
  'tracker': 'pisteur',
  'Transformer': 'Transformateur',
  'TRANSFORMER': 'TRANSFORMATEUR',
  'transformer': 'transformateur',
  'UPS': 'Alimentation Sans Interruption',
  'ups': 'alimentation Sans Interruption',
  'Ups': 'Alimentation Sans Interruption',
  'Grid': 'Réseau',
  'grid': 'réseau',
  'Inverter': 'Onduleur',
  'INVERTER': 'ONDULEUR',
  'inverter': 'Onduleur',
  'Gateway Comm.': 'Communication passerelle',
  'Breaker': 'Disjoncteur',
  'BREAKER': 'DISJONCTEUR',
  'breaker': 'disjoncteur',
  'Computed.': 'Calculé',
  'gateway': 'passerelle',
  'computed': 'calculé',
  // ANNUNCIATOR
  'Device ID': 'Identification de l\'appareil',
  'Mog Alarm': 'Alarme de jauge d\'huile magnétique',
  'OC EF Trip': 'Surintensité Déclenchement du défaut à la terre',
  'UV OV Trip': 'Déclenchement de sous-tension ou de surtension', 
  'Master Trip': 'Déclenchement principal',
  'TF OTI Trip': 'Déclenchement de l\'indicateur de température d\'huile du transformateur',
  'TF WTI Trip': 'Déclenchement de l\'indicateur de température de bobinage du transformateur', 
  'TF OTI Alarm': 'Alarme de l\'indicateur de température de l\'huile du transformateur', 
  'TF WTI Alarm': 'Alarme de l\'indicateur de température de bobinage du transformateur',
  'TF Bchlz Trip': 'Déclenchement Buchholz du transformateur',
  'TF Bchlz Alarm': 'Alarme Buchholz du transformateur',
  // BREAKER
  'Trip Circuit Healthy': 'Circuit de déclenchement est sain',
  'DC Supply': 'Alimentation CC',
  'Breaker On': 'Disjoncteur est activé',
  'Breaker OFF': 'Disjoncteur est désactivé',
  'Breaker Trip': 'Disjoncteur est déclenché',
  'Spring Charge': 'Charge de ressort',
  // ENERGY METER
  'GA (%)': 'Disponibilité du réseau (%)',
  'PA (%)': 'Disponibilité de la centrale solaire (%)',
  //pr
  'R-Phase (V)': ' Phase rouge (V)',
  'Y-Phase (V)': ' Phase jaune (V)',
  'B-Phase (V)': ' Phase bleue (V)',
  'Line Current 12 (A)': 'Courant de ligne 12 (A)',
  'Line Current 23 (A)': 'Courant de ligne 23 (A)',
  'Line Current 31 (A)': 'Courant de ligne 31 (A)',
  'CUF (%)': 'Facteur d\'utilisation (%)',
  'RY-Line (V)': 'Ligne rouge-jaune (V)',
  'YB-Line (V)': 'Ligne jaune-bleue (V)',
  'BR-Line (V)': 'Ligne bleue-rouge (V)',
  'R-Phase-Thd (V)': 'Distorsion harmonique totale de phase rouge (V)',
  'Y-Phase-Thd (V)': 'Distorsion harmonique totale de phase jaune (V)',
  'B-Phase-Thd (V)': 'Distorsion harmonique totale de phase bleue (V)',
  'AC Power (kW)': 'Alimentation CA (kW)',
  'AC Yield (kW)': 'Rendement CA (kW)',
  'Frequency (Hz)': ' Fréquence (Hz)',
  'AC Power L1 (kW)': 'Ligne 1 d\'alimentation CA (kW)',
  'AC Power L2 (kW)': 'Ligne 2 d\'alimentation CA (kW)',
  'AC Power L3 (kW)': 'Ligne 3 d\'alimentation CA (kW)',
  'Temperature (°C)': 'Température (°C)',
  'Power Factor (kW)': 'Facteur de puissance (kW)',
  'Apparent Power (kW)': 'Puissance apparente (kW)',
  'Apparent Power 1 (kW)': 'Puissance apparente 1 (kW)',
  'Apparent Power 2 (kW)': 'Puissance apparente 2 (kW)',
  'Apparent Power 3 (kW)': 'Puissance apparente 3 (kW)',
  'R-Phase (A)': 'Phase rouge (A)',
  'Y-Phase (A)': 'Phase jaune (A)',
  'B-Phase (A)': 'Phase bleue (A)',
  'Power Factor': 'Facteur de puissance',
  'Power Factor 1 (kW)': 'Facteur de puissance 1 (kW)',
  'Power Factor 2 (kW)': 'Facteur de puissance 2 (kW)',
  'Power Factor 3 (kW)': 'Facteur de puissance 3 (kW)',
  'Reactive Power (kVAR)': 'Puissance réactive (kVAR)',
  'Reactive Power 1 (kW)': 'Puissance réactive 1 (kW)',
  'Reactive Power 2 (kW)': 'Puissance réactive 2 (kW)',
  'Reactive Power 3 (kW)': 'Puissance réactive 3 (kW)',
  'R-Phase-Thd (A)': 'Distorsion harmonique totale de phase rouge (A)',
  'Y-Phase-Thd (A)': 'Distorsion harmonique totale de phase jaune (A)',
  'B-Phase-Thd (A)': 'Distorsion harmonique totale de phase bleue (A)',
  'V Line Neutral AVG (kW)': 'Tension de ligne à neutre moyenne (kW)',
  'Active Export Day (kWh)': 'Exportation active du jour (kWh)',
  'Active Import Day (kWh)': 'Importation active du jour (kWh)',
  'Lifetime Generation (KWh)': 'Production à vie (KWh)',
  'Active Export Cumm. (kWh)': 'Exportation active cumulée (kWh)',
  'Active Import Cumm. (kWh)': 'Importation active cumulée (kWh)',
  'Cumm. Active Export Cumm. (kWh)': 'Totale des exportations actives cumulées (kWh)',
  'Cumm. Active Import Cumm. (kWh)': 'Totale des importations actives cumulées (kWh)',
  // INVERTER
  'AC Generation (kWh)': 'Production CA (kWh)',
  'Load 1 (kW)': 'Charge 1 (kW)',
  'Load 2 (kW)': 'Charge 2 (kW)',
  'Load 3 (kW)': 'Charge 3 (kW)',
  'AC Yield (kW)': 'Rendement CA (kW)',
  'BOS loss (kW)': 'Perte de l\'équilibre du système (kW)',
  'DC Power (kW)': 'Alimentation CC (kW)',
  'DC Yield (kW)': 'Rendement CC (kW)',
  'DC Generation (kWh)': 'Production CC (kWh)',
  'Down Time (kWh)': 'Durée de l\'arrêt (kWh)',
  'Grid Lost': 'Réseau perdu',
  'R-Phase (V)': ' Phase rouge (V)',
  'Y-Phase (V)': ' Phase jaune (V)',
  'B-Phase (V)': ' Phase bleue (V)',
  'Stop Time': 'Heure d\'arrêt',
  'DC Current (A)': 'Courant continu (A)',
  'DC Voltage (V)': 'Tension CC (V)',
  'Efficiency (%)': 'Efficacité (%)',
  'Max Energy (kW)': 'Énergie maximale (kW)',
  'Min Energy (kW)': 'Énergie minimale (kW)',
  'Start Time': ' Heure de démarrage',
  'AC Power L1 (kW)': 'Ligne 1 d\'alimentation CA (kW)',
  'AC Power L2 (kW)': 'Ligne 2 d\'alimentation CA (kW)',
  'AC Power L3 (kW)': 'Ligne 3 d\'alimentation CA (kW)',
  'Down Energy (kWh)': 'Baisse de l\'énergie (kWh)',
  'Energy Today (kWh)': 'Énergie produite aujourd\'hui (kWh)',
  'Inv OP State': 'État de fonctionnement des onduleurs',
  'Working Hour': 'Heure de travail',
  'Energy Import (kW)': 'Importation d\'énergie (kW)',
  'Inv Temp (°C)': 'Température de l\'onduleur (°C)',
  'R-Phase (A)': 'Phase rouge (A)',
  'Y-Phase (A)': 'Phase jaune (A)',
  'B-Phase (A)': 'Phase bleue (A)',
  'Min DC Energy (kW)': 'Énergie minimale en courant continu (kW)',
  'Apparent Power (kW)': 'Puissance apparente (kW)',
  'BOS Efficiency (%)': 'Efficacité de l\'équilibre du système (%)',
  'Inverter Temp 2 (°C)': 'Température de l\'onduleur 2 (°C)',
  'POA Irradiance (W/m²)': 'Irradiance du plan du réseau (W/m²)',
  'Inv Status': 'Statut de l\'onduleur',
  'Leakage Current': 'Fuite de courant',
  'Inverter Status 1': 'Statut de l\'onduleur 1',
  'Inverter Status 2': 'Statut de l\'onduleur 2',
  'Inverter Status 3': 'Statut de l\'onduleur 3',
  'Inverter Status 4': 'Statut de l\'onduleur 4',
  'Cumm. AC Generation (kWh)': 'Production totale de courant alternatif (kWh)',
  'DC Cabinet Status': 'Statut de l\'armoire à courant continu',
  'Off Grid Frequency (Hz)': 'Fréquence hors réseau (Hz)',
  'Total Working Hour': 'Heure de travail totale',
  'Energy Import Daily (kW)': 'Importation d\'énergie quotidienne (kW)',
  'DC Cabinet OC Status': 'Statut de surintensité de l\'armoire en courant continu',
  // MFM
  'V Line Avg (V)': 'Tension de ligne moyenne',
  'Apparent Power Avg (kWA)': 'Puissance apparente moyenne (kWA)',
  'Total Avg Current (A)': 'Total du courant moyen (A)',
  'V Line Neutral AVG (kW)': 'Tension de ligne à neutre moyenne (kW)',
  'Power (kW)': 'Pouvoir (kW)',
  'Energy (kWh)': 'Énergie (kWh)',
  'Channel (A)': 'Canal (A)',
  'Voltage (V)': 'Tension (V)',
  'Over Volt': 'Surtension',
  'Earth Trip': 'Déclenchement de terre',
  'Phase Trip': 'Déclenchement de phase',
  'Under Volt': 'Sous tension',
  'Unit Ready': 'Appareil est prêt',
  'Earth Fault': 'Défaut de terre',
  'Fuse Failure': 'Défaillance du fusible',
  'Internal Fault': 'Défaut interne',
  'Breaker Status': 'Statut du disjoncteur',
  'SPD Status': 'Statut du dispositif de protection contre les surtensions',
  'Total Current (A)': 'Courant total (A)',
  // SOIL SENSOR
  'ISC Ref (A)': 'Courant de court-circuit de référence (A)',
  'GEFF Ref (W/m²)': 'Rayonnement de référence (W/m²)',
  'ISC Test (A)': 'Courant de court-circuit de test (A)',
  'GEFF Test (W/m²)': 'Rayonnement de test(W/m²)',
  'Soil Ratio (%)': 'Taux de sol (%)',
  'SP Daily Avg(%)': 'Pourcentage de salissure moyenne quotidienne (%)',
  'SR Daily Avg(%)': 'Taux de salissure moyenne quotidienne (%)',
  'Percentage Ratio 1': 'Taux de pourcentage 1',
  'Percentage Ratio 2': 'Taux de pourcentage 2',
  'Soiling Ratio 1': 'Taux de salissure 1',
  'Soiling Ratio 2': 'Taux de salissure 2',
  'Transmit Loss 1': 'Perte pendant la transmission 1',
  'Transmit Loss 2': 'Perte pendant la transmission 2',
  'Ref Module Temp (°C)': 'Température du panneau solaire de référence (°C)',
  'Soil Percentage (%)': 'Pourcentage de sol (%)',
  'Test Module Temp (°C)': 'Température du panneau d\'essai solaire (°C)',
  // TRACKER
  'Current (A)': 'Courant (A)',
  'Accuracy (%)': 'Précision',
  'Wind Speed (km/h)': 'Vitesse du vent (km/h)',
  'Mode Status': 'Statut du mode',
  'Actual Angle (°)': 'Angle réel (°)',
  'Error Status': 'Statut de l\'erreur',
  'Target Angle (°)': 'Angle défini (°)',
  'Input Voltage (V)': 'Tension d\'entrée (V)',
  'Deviation Angle (°)': 'Angle de déviation (°)',
  // TRANSFORMER
  'PRV': 'Soupape de surpression',
  'Mog Trip': 'Déclenchement de la jauge d\'huile magnétique',
  'Mog Alarm': 'Alarme de jauge d\'huile magnétique',
  'OT Trip Set (°C)': 'Déclencheur de la température de l\'huile est réglé (°C)',
  'WT Trip Set (°C)': 'Déclencheur de la température du bobinage est activé (°C)',
  'OT Alarm Set (°C)': 'Alarme de température d\'huile réglée (°C)',
  'WT Alarm Set (°C)': 'Alarme de température de bobinage est réglée (°C)',
  'Actual OT (°C)': 'Température réelle de l\'huile (°C)',
  'Actual WT (°C)': 'Température réelle du bobinage (°C)',
  'Buchloz Trip': 'Déclenchement Buchholz',
  'Max OT (°C)': 'Température maximale de l\'huile (°C)',
  'Max WT (°C)': 'Température maximale du bobinage (°C)',
  'Buchloz Alarm': 'Alarme Buchholz',
  // UPS
  'On Battery': 'Sur batterie',
  'Bypass': 'Contourner',
  'Health': 'Santé',
  'Backup Time': 'Heure de sauvegarde',
  'Load (kW)': 'Charge (kW)',
  'Power Factor': 'Facteur de puissance',
  'B-Phase (A)': 'Phase bleue (A)',
  'Battery Current (A)': 'Courant de batterie (A)',
  'Battery Volt (V)': 'Tension de batterie (V)',
  'Invalid Voltage (V)': 'Tension invalide (V)',
  'AC I/P Curr (A)': 'Courant d\'entrée alternatif (A)', 
  'AC I/P Volt (V)': 'Tension d\'entrée CA (V)',
  'O/P Frequency (Hz)': 'Fréquence de sortie (Hz)',
  'AC O/P Curr (A)': 'Courant de sortie alternatif (A)',
  'AC O/P Volt (V)': 'Tension de sortie CA (V)',
  'Rectifier Voltage (V)': 'Tension du redresseur (V)',
  'Battery Temperature (°C)': 'Température de la batterie (°C)',
  // WEATHER STATION
  'Humidity': 'Humidité',
  'Pressure (atms)': 'Pression (atms)',
  'Pressure': 'Pression',
  'Direction (deg)': 'Direction (deg)',
  'Direction': 'Direction',
  'Radiation (W/m²)': 'Rayonnement (W/m²)',
  'Radiation': 'Rayonnement',
  'Rain Gauge (mm)': 'Pluviomètre (mm)',
  'Rain Gauge': 'Pluviomètre',
  'Roll Angle (Radian)': 'Angle de rotation (Radian)',
  'Roll Angle': 'Angle de rotation', 
  'Wind Speed (m/s)': 'Vitesse du vent (m/s)',
  'Wind Speed': 'Vitesse du vent',
  'Cloud Cover': 'Couverture nuageuse',
  'Module Temp (°C)': 'Température du panneau solaire (°C)',
  'Module Temp': 'Température du panneau solaire',
  'Pitch Angle (Radian)': 'Angle d\'inclinaison (Radian)',
  'Pitch Angle': 'Angle d\'inclinaison',
  'Ambient Temp (°C)': 'Température ambiante (°C)',
  'Ambient Temp': 'Température ambiante',
  'GHI Insolation (kWh/m²)': 'Insolation de l\'irradiation horizontale globale (kWh/m²)',
  'GHI Insolation': 'Insolation de l\'irradiation horizontale globale',
  'POA Insolation (kWh/m²)': 'Insolation du plan du réseau (kWh/m²)',
  'POA Insolation': 'Insolation du plan du réseau',
  'Aux Supply (V)': 'Alimentation auxiliaire (V)',
  'Aux Supply': 'Alimentation auxiliaire',
  'POA (W/m²)': 'Plan du réseau (W/m²)',
  'POA': 'Plan du réseau',
  'GHI (W/m²)': 'Irradiance Horizontale Globale (W/m²)',
  'GHI': 'Irradiance Horizontale Globale',
  // ZMU
  'DC Power (kW)': 'Alimentation CC (kW)',
  'DC Current (A)': 'Courant continu (A)',
  'DC Voltage (V)': 'Tension CC (V)',
  'Total ZMU Power (kW)': 'Puissance totale de I\'appareil de surveillance de zone (kW)',
  'Computed DC Power (kW)': 'Puissance en courant continu calculée (kW)',
  'Total ZMU Current (A)': 'Courant total de I\'appareil de surveillance de zone (A)',
  'Computed DC Current (A)': 'Courant continu calculé (A)',
  'Total Computed ZMU Power (kW)': 'Puissance totale calculée de l\'appareil de surveillance de zone (kW)',
  'Total Computed ZMU Current (A)': 'Courant total calculé de l\'appareil de surveillance de zone (A)',
  // ERROR MESSAGES
  'Error': 'Erreur',
  'Warning': 'Avertissement',
  'Successful': 'succès',
  'Success': 'succès',
  'Unknown Error': 'Erreur inconnue',
  'Not Found': 'Pas trouvé',
  'Invalid date': 'Date invalide',
  'Unable to read cache components': 'Impossible de lire les composants du cache',
  'Cache not found': 'Cache pas trouvé',
  'Cache could not be deleted': 'Le cache n\'a pas pu être supprimé',
  'Cannot update without condition': 'Impossible d\'actualiser sans condition',
  'Something went wrong': 'Quelque chose a mal tourné',
  'Some error occured': 'Une erreur est survenue',
  'Error while reading data': 'Erreur pendant la lecture des données',
  'Plants are not assigned to this user': 'Les centrales solaires ne sont pas attribuées à cet utilisateur',
  'TypeError: Cannot read properties of undefined (reading \'data\')': 'TypeError : Impossible de lire les propriétés d\'une valeur indéfinie (lecture de \'data\')',
  'Session has expired expired': 'La session a expiré',
  //Plants are not assigned to this user
  'The specified key does not exist.': 'La clé spécifiée n\'existe pas.',
  'Too many requests, please try again later.': 'Trop de demandes, réessayez plus tard.',
  'Not a Registered User': 'Utilisateur pas enregistré',
  'Invalid Password': 'Mot de passe invalide',
  'This Login Has Expired': 'Cette connexion a expiré',
  'Some issue in the server': 'Problème dans le serveur',
  'Date Limit Exceeded!': 'Date de la limite dépassée!',
  'no records': 'Pas de dossiers',
  'Plant ID is required': 'Identification de la centrale solaire est exigée',
  'Block ID is required': ' Identification du bloc est exigée',
  'Inverter room is required': 'Salle de l\'onduleur est exigée',
  'Index is required': 'Index est exigé',
  'Query param is required': 'Paramètre de requête exigé',
  'Date is required': 'Date est exigée',
  'Date from is required': 'Date de début est exigée',  
  'Date to is required': 'Date de fin est exigée',
  'Date from cannot be greater than Date to': 'Date de début ne peut pas être supérieure à la date de fin.',
  'Starting date is required': 'Date de début est exigée',
  'Ending date is required': 'Date de fin est exigée',
  'Component param is required': 'Paramètre du composant est exigé',
  'Type is required': 'Type est exigé',
  'Type param is required': 'Paramètre de type est exigé',
  'Ending date required': 'Date de fin est exigée',
  'Starting date required': 'Date de début est exigée',
  'Interval is required': 'Intervalle est exigé',
  'Module is required': 'Panneau solaire est exigé',
  'Device is required': 'Appareil est exigé',
  'ID list is required': 'Liste d\'identification est exigée',
  'Inverter ID is required': 'Identification de l\'onduleur exigée',
  'SMB ID is required': 'Identification de la boîte de combinaison de la corde est exigée',
  'WS ID is required': 'Identification de la station de surveillance météorologique exigée',
  'Search list is required': 'Liste de recherche est exigée',
  'Email is required': 'E-mail est exigé',
  'Not a valid email': 'E-mail pas valide',
  'The password must be 3+ chars long and contain a number': 'Le mot de passe doit comporter plus de 3 caractères et contenir un chiffre.',
  'You are not allowed to make an API call': 'Vous n\'êtes pas autorisé à effectuer un appel API', 
  'Login expired': 'Connexion expirée',
  'Alert updated successfully': 'Alerte a été actualisée avec succès',
  'Alert update failed!': 'Échec de l\'actualisation de l\'alerte!',
  'Please select a valid date': 'Sélectionner une date valide',
  'Please select some option': 'Sélectionner une option',
  'Changes were saved successfully': 'Les modifications ont été sauvegardées avec succès',
  'Failed to save the changes': 'Échec de la sauvegarde des modifications',
  'Please select String Inverters in order to check graph': 'Sélectionner les onduleurs à cordes afin de vérifier le graphique',
  'No File To Download': 'Aucun fichier à télécharger',
  'Template is successfully updated': 'Modèle est actualisé avec succès',
  'There was some issue while making the change': 'Il y a eu un problème pendant la modification',
  'Template is successfully created': 'Modèle est créé avec succès',
  'Template has been deleted': 'Modèle a été supprimé',
  'Forecasted Generation is not edited!': 'La production prévue n\'est pas éditée',
  'Parameters are not configured': 'Les paramètres ne sont pas configurés',
  'Please enter a valid Email': 'Saisir un e-mail valide',
  'Please check email for further instructions': 'Vérifier l\'e-mail pour plus d\'instructions',
  'Please try again after': 'Réessayez après',
  'Invalid email': 'E-mail invalide',
  'Please enter a valid date to view dashboard': 'Saisir une date valide pour visualiser le tableau de bord',
  'Not-Connected channel cannot be selected': 'Pas connecté, le canal ne peut pas être sélectionné',
  'Please select atleast one SMB or Channel in order to plot graph': 'Sélectionner au moins une boite de combinaison de cordes ou un canal afin de tracer un graphique',
  'Minimun one device will be selected': 'Un seul appareil au minimum sera sélectionné',
  'This link has expired': 'Ce lien est expiré',
  'Please fill new password and confirm password!': 'Remplissez un nouveau mot de passe et confirmez le !',
  'Password does not match': 'Le mot de passe ne correspond pas',
  'Your password should not be same as your previous password': 'Votre mot de passe ne doit pas être identique à votre mot de passe précédent.',
  'Password Successfully Updated! Email is sent with password in it': 'Mot de passe actualisé avec succès ! Un e-mail contenant le mot de passe est envoyé',
  'Password Update Failed': 'Échec de l\'actualisation du mot de passe',
  'Your password is not strong. Please fulfill the criteria!': 'Votre mot de passe n\'est pas assez fort. Remplissez les critères !',
  'Could not go back to login page, please try again': 'Le retour à la page de connexion n\'est pas possible, réessayez.',
  'You have 10 days to reset the password': 'Vous avez {num} jours pour réinitialiser le mot de passe',
  'Please Select Any Component': 'Sélectionner un composant',
  'Minimum one tracker will be selected': 'Au moins un pisteur sera sélectionné',
  'No ZMU Configured': 'Aucune appareil de surveillance de zone n\'est configurée',
  'Please Select Channel/ZMU': 'Sélectionner le canal / l\'appareil de surveillance de zone',
  // Dashboard
  'Analytics': 'Analytiques',
  'Device Control': 'Contrôle des appareils',
  'Other Sensor': 'Autre capteur',
  'Inverter Ranking': 'Classement des onduleurs',
  'Down Time Analysis': 'Analyse de la durée de l\'arrêt',
  'Live Dashboard': 'Tableau de bord en direct',
  'Zone Monitoring': 'Surveillance de la zone'
};
